import { Post, Group } from 'lib/_types'

import PostContent from 'components/Post/PostContent'

import './style.scss'

const PostEditablePost = ({
  post,
  group,
}: {
  post: Post
  group?: Partial<{ data: Group }>
}) => {
  return (
    <div className="PostEditablePost">
      <PostContent
        post={post}
        group={group}
        isShared={false}
        noText
        forceMultiplePostImage
        isEdit
      />
    </div>
  )
}

export default PostEditablePost
